import React from "react"
import * as SliderPrimitive from "@radix-ui/react-slider"

import { cn } from "@/utils/styles"

interface SliderQuestionnaireProps extends React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root> {
  maxRangeText?: string
  minRangeText?: string
  colors?: string[]
}

const SliderQuestionnaire = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  SliderQuestionnaireProps
>(({ className, maxRangeText, minRangeText, colors, ...props }, ref) => {
  const hasColors = Array.isArray(colors) && colors.length > 0
  const trackStyle = hasColors
    ? { backgroundImage: `linear-gradient(to right, ${colors.join(', ')})` }
    : undefined

  if (props.disabled) {
    return (
      <SliderPrimitive.Root
        ref={ref}
        className={cn(
          "relative flex flex-col gap-4 w-full touch-none select-none items-center",
          className,
        )}
        {...props}
      >
        <SliderPrimitive.Track
          className={cn(
            "relative flex items-center p-2 h-5 w-full grow overflow-hidden rounded-full",
            !hasColors ? "bg-[#D8DBE0]" : 'bg-opacity-50',
          )}
          style={trackStyle}
        >
          <div className="absolute h-2 w-2 rounded-lg bg-[#00000033]" />
          <div className="absolute right-[8px] h-2 w-2 rounded-lg bg-[#00000033]" />
          <SliderPrimitive.Range className="absolute -z-[1] h-full bg-[#D8DBE0]" />
        </SliderPrimitive.Track>
        <SliderPrimitive.Thumb className="relative -top-[4px] flex justify-center items-center h-[1.75rem] w-[1.75rem] cursor-pointer rounded-full bg-white shadow-sm  ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none outline-none">
          <p className="absolute -top-7 left-1/2 -translate-x-1/2 font-medium text-lg">
            {props.value?.[0]}
          </p>
          <div className="h-2.5 w-2.5 bg-[#000000] rounded-lg" />
        </SliderPrimitive.Thumb>
        {minRangeText && maxRangeText &&
          <div className="w-full flex flex-row justify-between">
            <p className="text-sm text-secondary">{minRangeText}</p>
            <p className="text-sm text-secondary">{maxRangeText}</p>
          </div>
        }
      </SliderPrimitive.Root>  
    )
  }

  return (
  <SliderPrimitive.Root
    ref={ref}
    className={cn(
      "relative flex flex-col gap-4 w-full touch-none select-none items-center",
      className,
    )}
    {...props}
  >
    <SliderPrimitive.Track
      className={cn(
        "relative flex items-center p-2 h-5 w-full grow overflow-hidden rounded-full",
        !hasColors && "bg-[#D8DBE0]",
      )}
      style={trackStyle}
    >
      <div className="absolute h-2 w-2 rounded-lg bg-[#00000033]" />
      <div className="absolute right-[8px] h-2 w-2 rounded-lg bg-[#00000033]" />
      <SliderPrimitive.Range className="absolute -z-[1] h-full bg-[#D8DBE0]" />
    </SliderPrimitive.Track>
    <SliderPrimitive.Thumb className="relative -top-[4px] flex justify-center items-center h-[1.75rem] w-[1.75rem] cursor-pointer rounded-full bg-white shadow-sm  ring-offset-background transition-colors focus-visible:outline-none disabled:pointer-events-none">
      <p className="absolute -top-7 left-1/2 -translate-x-1/2 font-medium text-lg">
        {props.value?.[0]}
      </p>
      <div className="h-2.5 w-2.5 bg-black rounded-lg" />
    </SliderPrimitive.Thumb>
    <div className="w-full flex flex-row justify-between">
      <p className="text-sm text-secondary">{minRangeText}</p>
      <p className="text-sm text-secondary">{maxRangeText}</p>
    </div>
  </SliderPrimitive.Root>
  )
}
)
SliderQuestionnaire.displayName = SliderPrimitive.Root.displayName

export { SliderQuestionnaire } 